import {format} from "date-fns";
import React, {Component} from "react";
import {Bar} from "react-chartjs-2";
import DataTable from "react-data-table-component";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApiConnect from "../../../Utils/ApiConnect";

class Report extends Component {
  constructor() {
    super();
this.state = {
      Fetchdata: [],
      loading: true,
      startDate: new Date(),
      endDate: new Date(),
      WaiterList: [],
      waiter: "",
      Bardata: [],
      filterText: "",
    };
    this.columns = [
      {
        name: "Product Name",
        selector: row => row.product,
        sortable: true,
      },
      {
        name: "Category",
        selector: row => row.category,
        sortable: true,
      },
      {
        name: "Complete Order",
        selector: row => row.order,
        sortable: true,
      },
      {
        name: "Modify Order",
        selector: row => row.modify,
        sortable: true,
      },
      {
        name: "Delete/Canceled order",
        selector: row => row.delete,
        sortable: true,
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  waiterListFetch = () => {
    ApiConnect.get("POS/Orders/WaiterList")
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({ WaiterList: response.data.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  componentDidMount() {
    this.waiterListFetch();
  }
  FetchKitchenReport = () => {
    this.setState({ loading: true });
    ApiConnect.get(
      `POS/Orders/Report?from=${format(
        this.state.startDate,
        "yyyy-MM-dd"
      )}&to=${format(
        this.state.endDate,
        "yyyy-MM-dd"
      )}&location=kitchen,bar&waiter=${this.state.waiter}`
    )
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({
            Fetchdata: response.data.data,
            loading: false,
            Bardata: {
              labels: response.data.data.map((p) => p.product),
              datasets: [
                {
                  label: "Complete",
                  data: response.data.data.map((p) => parseInt(p.order)),
                  backgroundColor: "rgb(75, 192, 192)",
                },
                {
                  label: "Modify",
                  data: response.data.data.map((p) => parseInt(p.modify)),
                  backgroundColor: "rgb(255, 206, 86)",
                },
                {
                  label: "Delete",
                  data: response.data.data.map((p) => parseInt(p.delete)),
                  backgroundColor: "rgb(255, 99, 132 )",
                },
              ],
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <div className="container">
        <div className="card">
          <div className="card-header">
            <div className="input-group">
              <label htmlFor="start">From Date</label>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                className="form-control"
                maxDate={new Date()}
                closeOnScroll={true}
                selected={this.state.startDate}
                value={this.state.startDate}
                onChange={(e) => this.setState({ startDate: e })}
                placeholderText="Start Date"
              />
            </div>
            <div className="input-group">
              <label htmlFor="start">To Date</label>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                className="form-control"
                maxDate={new Date()}
                closeOnScroll={true}
                selected={this.state.endDate}
                value={this.state.endDate}
                onChange={(e) => this.setState({ endDate: e })}
                placeholderText="End Date"
              />
            </div>
            <div className="input-group">
              <label htmlFor="waiter">Waiter</label>
              <select
                className="form-control"
                name="waiter"
                onChange={(e) => {
                  this.setState({ waiter: e.target.value });
                }}
              >
                <option value="">Select Waiter</option>
                {this.state.WaiterList
                  ? this.state.WaiterList.map((waiter, index) => (
                      <option value={waiter.id} key={index}>
                        {waiter.name}
                      </option>
                    ))
                  : ""}
              </select>
            </div>

            <button
              className="btn btn-info"
              onClick={(e) => this.FetchKitchenReport()}
            >
              Fetch
            </button>
          </div>

          <div className="card-body">
            <div className="col-md-12">
              {!this.state.loading ? (
                <React.Fragment>
                  <Bar height={"120vh"} data={this.state.Bardata} />
                  <hr />
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
            {!this.state.loading ? (
              <React.Fragment>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={e => this.setState({ filterText: e.target.value })}
                  />
                </div>
                <DataTable
                  className="table"
                  keyField="id"
                  columns={this.columns}
                  data={this.state.Fetchdata.filter(item =>
                    Object.values(item).some(val =>
                      String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
                    )
                  )}
                  pagination
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  paginationPerPage={10}
                  customStyles={this.customStyles}
                  filter
                  exportable
                  loading={this.state.loading}
                />
              </React.Fragment>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Report;
